<template>
  <div>
    <nav
      class="
        container
        px-6
        py-8
        mx-auto
        md:flex md:justify-between md:items-center
      "
    >
      <div class="flex items-center justify-between">
        <router-link
          to="/"
          class="
            text-xl
            md:text-2xl
            hover:text-indigo-400
            flex
            items-center
          "
          >
          <img class="inline-block h-10 mr-5" src="../assets/jf.svg" alt="">
          <a href="" class="inline-block items-center">JerryFriends</a>
        </router-link>
        <!-- Mobile menu button -->
        <div @click="toggleNav" class="flex md:hidden">
          <button
            type="button"
            class="
              text-gray-100
              hover:text-gray-400
              focus:outline-none focus:text-gray-400
            "
          >
            <svg fill="black" viewBox="0 0 24 24" class="w-6 h-6">
              <path
                fill-rule="evenodd"
                d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
              ></path>
            </svg>

          </button>
        </div>
      </div>

      <!-- Mobile Menu open: "block", Menu closed: "hidden" -->
      <ul
        :class="showMenu ? 'flex' : 'hidden'"
        class="
          flex-col
          mt-8
          space-y-4
          md:flex md:space-y-0 md:flex-row md:items-center md:space-x-10 md:mt-0
        "
      >
        <li class="hover:text-indigo-400"><router-link to="/about">關於我們</router-link></li>
        <li class="hover:text-indigo-400"><router-link to="/teams">尋找團隊</router-link></li>
        <li class="hover:text-indigo-400"><router-link to="/partners">尋找夥伴</router-link></li>
        <router-link to="/joinus" class="btn btn-yello h-fit w-fit">加入我們</router-link>
      </ul>
    </nav>
  </div>
</template>


<script>
import { ref } from 'vue';
export default {
  setup() {
    let showMenu = ref(false);
    const toggleNav = () => (showMenu.value = !showMenu.value);
    return { showMenu, toggleNav };
  },
};
</script>